// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__1eKXP","content":"SubHeader_content__2gKT5","btnBack":"SubHeader_btnBack__1mFtl","line":"SubHeader_line__2A9iU"};